import { useRouteError, Link } from "react-router-dom";
import { Box, Typography, Button, Container } from "@mui/material";
import { Home, ArrowBack } from "@mui/icons-material";

const ErrorPage = () => {
  const error = useRouteError();

  return (
    <Container maxWidth="md" sx={{ py: 8, textAlign: 'center' }}>
      <Box>
        <Typography variant="h1" component="h1" sx={{ fontSize: '4rem', mb: 2 }}>
          🐐
        </Typography>
        <Typography variant="h3" component="h2" gutterBottom>
          Oops! Something went wrong!
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          {error?.statusText || error?.message || "An unexpected error occurred"}
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button
            component={Link}
            to="/"
            variant="contained"
            startIcon={<Home />}
            size="large"
          >
            Go Home
          </Button>
          <Button
            onClick={() => window.history.back()}
            variant="outlined"
            startIcon={<ArrowBack />}
            size="large"
          >
            Go Back
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default ErrorPage;